import {
  API_GET_INSPECTION_STATUS,
  API_GET_JUDGMENT_STATUS,
  API_INSPECTION_STATUS_DETAIL,
} from "../../constants/api";
import API from "..";

export const fetchInspectionStatus = async (filter) => {
  try {
    if (!filter.template) {
      filter.template = '';
    }
    const response = await API.get(API_GET_INSPECTION_STATUS, {
      params: filter,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const fetchJudgmentStatus = async (params) => {
  try {
    const response = await API.get(API_GET_JUDGMENT_STATUS, {
      params: params,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const fetchInspectionStatusDetail = async (params) => {
  try {
    const response = await API.get(API_INSPECTION_STATUS_DETAIL, {
      params: params,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
